import { render } from "./WCSpinnerRoot.vue?vue&type=template&id=59c66b23&scoped=true"
import script from "./WCSpinnerRoot.vue?vue&type=script&lang=js"
export * from "./WCSpinnerRoot.vue?vue&type=script&lang=js"

import "./WCSpinnerRoot.vue?vue&type=style&index=0&id=59c66b23&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c66b23"]])

export default __exports__